"use client";

import useLocaleDetection from "@/lib/hooks/useLocaleDetection";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import { HTMLAttributes, useEffect, useState } from "react";
import { Button } from "../ui/button";

const RegionTips: React.FC<{
  className?: HTMLAttributes<HTMLDivElement>["className"];
}> = ({ className }) => {
  const { isChineseUser } = useLocaleDetection();

  const [value, setValue] = useState(true);

  useEffect(() => {
    const storageValue = window.localStorage.getItem("RegionTips");

    if (storageValue) {
      setValue(true);
    } else {
      setValue(false);
    }
  }, []);

  if (!isChineseUser || value) {
    return null;
  }

  return (
    <div
      className={cn(
        "relative mx-auto flex w-full items-center justify-center border-b border-neutral-100 bg-white p-4 text-base font-medium text-neutral-700",
        className,
      )}
    >
      请访问中国大陆站点
      <a href="https://talencat.cn" className="mx-1 inline-block text-primary">
        talencat.cn
      </a>
      以获得更<b className="text-neutral-900">稳定</b>、
      <b className="text-neutral-900">便捷</b>
      的服务
      <a
        href="https://talencat.cn"
        className="ml-4 flex items-center text-primary hover:text-primary/80"
      >
        前往
        <ChevronRight size={18} strokeWidth={2.5} />
      </a>
      <div className="absolute right-3 top-3 ml-20 flex items-center justify-center font-normal">
        <Button
          variant={"link"}
          size={"sm"}
          className="font-normal"
          onClick={() => {
            window.open(
              "https://talencat.com/zh/resume-guides/transfer-data-to-talencat-cn",
            );
          }}
        >
          了解如何迁移
        </Button>
        <Button
          variant={"ghost"}
          size={"sm"}
          className="font-normal"
          onClick={() => {
            setValue(true);
            window.localStorage.setItem("RegionTips", "true");
          }}
        >
          知道了
        </Button>
      </div>
    </div>
  );
};

export default RegionTips;
